import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import './app.scss';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Error from './common/error/error';
import WelcomeLayout from './common/layouts/welcome-layout';
import { mainRoutes } from './routes/routes';
import './i18n';
import { DataService } from './app/configure/service/deviceservice';
import { catchErrorsForAlerts, loadRichMaps, sendAlertToServer, } from './app/workspaces/floor/util';
import { Constants } from './app/configure/models/constants';
import { NatsDebugPanel } from './app/workspaces/debug/nats-debug';
const router = createBrowserRouter([
    {
        path: '/',
        element: _jsx(WelcomeLayout, {}),
        errorElement: _jsx(Error, {}),
        children: [...mainRoutes],
    },
]);
function App() {
    useEffect(() => {
        var _a;
        const dataService = new DataService();
        console.log('App mounted');
        // Need to store these tokens in the landing URL itself, before redirection to /home happens, since context API call now may not return a token due to session invalidation
        const params = new URLSearchParams(window.location.search);
        const cAuthToken = params.get('cauthtoken');
        const token = (_a = params.get('token')) === null || _a === void 0 ? void 0 : _a.split('?')[0];
        // Store if not present
        if (!dataService.getDeviceToken())
            dataService.setDeviceToken(token);
        if (!dataService.getCAuthToken())
            dataService.setCAuthToken(cAuthToken);
        void loadRichMaps().catch((err) => {
            void sendAlertToServer(Constants.ALERTS.RICHMAPS_ERROR, JSON.stringify(err));
        });
        catchErrorsForAlerts();
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx(RouterProvider, { router: router }), _jsx(NatsDebugPanel, {})] }));
}
export default App;
